import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import type { TargetareTier } from "@/types/targetare";
import { TIER_DESCRIERI } from "@/utils/targetareFormatting";

type TierBadgeProps = {
  tier: TargetareTier | null;
  className?: string;
};

const CULORI: Record<TargetareTier, string> = {
  A: "bg-ds-blue-600 text-black hover:bg-ds-blue-600",
  B: "bg-ds-green-500 text-black hover:bg-ds-green-500",
  C: "bg-ds-amber-500 text-black hover:bg-ds-amber-500",
  D: "bg-ds-text-400 text-navy-800 hover:bg-ds-text-400",
};

export function TierBadge({ tier, className }: TierBadgeProps) {
  if (!tier) {
    return (
      <Badge
        variant="outline"
        className={cn("font-mono", className)}
        title="Sub pragul de dimensiune, fără serviciu în scop indiferent de dimensiune"
      >
        –
      </Badge>
    );
  }
  return (
    <Badge
      className={cn("font-mono", CULORI[tier], className)}
      title={TIER_DESCRIERI[tier]}
    >
      {tier}
    </Badge>
  );
}
